import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestBankDetailsList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/bank-master`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/bank-master?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

export function requestBankDetailsCreate(params) {
  return fetch.post(`${BASE_URL}/api/app/bank-master`, params);
}

export function requestBankDetailsUpdate(data) {
  const body = { ...data }
  delete body["_id"]
  return fetch.put(`${BASE_URL}/api/app/bank-master/${data._id}`, body)
}
